import { OperationOutcome, Practitioner } from '@medplum/fhirtypes';
import { useResource } from '@medplum/react';
import { useParams } from 'react-router-dom';

// ---------------------------------------------------------------------------
type Options = {
  practitionerId?: string;
  ignoreMissingPractitionerId?: boolean;
  setOutcome?: (outcome: OperationOutcome) => void;
};

// ---------------------------------------------------------------------------
export const usePractitioner = (
  options?: Options
): Practitioner | undefined => {
  const { practitionerId } = useParams();
  if (
    !(practitionerId || options?.practitionerId) &&
    !options?.ignoreMissingPractitionerId
  ) {
    throw new Error('Practitioner ID not found');
  }

  const id = practitionerId || options?.practitionerId;

  // ---------------------------------------------------------------------------
  return useResource<Practitioner>(
    { reference: `Practitioner/${id}` },
    options?.setOutcome
  );
};
